export const enUS_globalTips = {
  'notfound': 'Sorry, the page you visited does not exist.',
  'global.tips.unauthorized': 'Sorry, you are not authorized to access this page.',
  'global.tips.loginResult': 'When you see this page, it means you are logged in.',
  'global.tips.goToLogin': 'Go To Login',
  'global.tips.username': 'Username',
  'global.tips.enterUsernameMessage': 'Please enter your Username!',
  'global.tips.password': 'Password',
  'global.tips.enterPasswordMessage': 'Please enter your Password!',
  'global.tips.rememberUser': 'Remember user',
  'global.tips.login': 'Login',
  'global.tips.backHome': 'Back Home',
  'global.tips.operation': 'Operation',
  'global.tips.authorize': 'Authorize',
  'global.tips.delete': 'Delete',
  'global.tips.create': 'Create',
  'global.tips.modify': 'Modify',
  'global.tips.search': 'Search',
  'global.tips.reset': 'Reset',
  'global.tips.deleteConfirm': 'Do you Want to delete these items?',
  'global.tips.loading': 'Loading...',
  'global.tips.theme.darkTooltip': 'Switch to dark theme',
  'global.tips.theme.lightTooltip': 'Switch to light theme',
  'global.tips.theme.noticeTooltip': 'Notifications',
  'global.tips.enterPasswordMessageAccount': 'Please enter account Password!',
};
